module.exports = __webpack_public_path__ + "img/profile-active-ic.4e0fb8af.svg";